import { render, staticRenderFns } from "./function-desc.vue?vue&type=template&id=1c18a000&scoped=true"
import script from "./function-desc.vue?vue&type=script&lang=js"
export * from "./function-desc.vue?vue&type=script&lang=js"
import style0 from "./function-desc.vue?vue&type=style&index=0&id=1c18a000&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c18a000",
  null
  
)

export default component.exports